core.constant('highchartsTranslationPL', {
  "T": {
    "HIGHCHARTS": {
      "LOADING": "Ładowanie...",
      "EXPORT_BUTTON_TITLE": "Export",
      "PRINT_BUTTON_TITLE": "Drukowanie",
      "RANGE_SELECTOR_FROM": "Od",
      "RANGE_SELECTOR_TO": "Do",
      "RANGE_SELECTOR_ZOOM": "Przybliżenie",
      "DOWNLOAD_PNG": "Pobierz obraz PNG",
      "DOWNLOAD_JPEG": "Pobierz obraz JPEG",
      "DOWNLOAD_PDF": "Pobierz obraz PDF",
      "DOWNLOAD_SVG": "Pobierz obraz SVG",
      "THOUSANDS_SEP": " ",
      "DECIMAL_POINT": ",",
      "PRINT_CHART": "Drukuj"
    }
  }
});
